import "./index.css"
import splash_image from '../../assets/images/hogcloud_splash_hero.webp';


const Home = () => {

    return <>

            <div className="cards-container-home">
            <div className="hero-image-wrap">
                <img src={splash_image} alt="Hogcloud hero" className="splash-image" onClick={() => {
                    window.location.href = "/shop"
                }} />
            </div>
                <section className="home-seo-intro">
                    <h1>Website Development, Custom Apps, and 3D Printing</h1>
                    <p>
                        Hogcloud helps families, creators, and small businesses turn ideas into
                        polished websites, practical custom applications, cloud-connected tools,
                        and custom 3D printed products.
                    </p>
                </section>
                <div className="card" onClick={() => {
                    window.location.href = "/shop";
                }}>
                    <h2 className="card-header">Custom 3D Printing</h2>
                    <div className="card-content">
                        <p>Shop unique 3D printed gifts, magnets, jewelry, decorations, and custom product ideas.</p>
                    </div>
            
                </div>
                <div className="card" onClick={() => {
                    window.location.href = "/services";
                }}>
                    <h2 className="card-header">Website Development</h2>
                    <div className="card-content">
                        <p>Modern websites, landing pages, ecommerce, SEO-friendly pages, and business integrations.</p>
                    </div>
                </div>
                <div className="card" onClick={() => {
                    window.location.href = "/services";
                }}>
                    <h2 className="card-header">Custom App Development</h2>
                    <div className="card-content">
                        <p>Business apps, workflow automation, dashboards, mobile-friendly tools, and cloud software.</p>
                    </div>
                </div>
            </div>
            

    
    
    </>;
  
    };


export default Home;
